/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M14.8328 9.4685 12 .75 9.1672 9.4685H0l7.4164 5.3883-2.8328 8.7186L12 18.187l7.4164 5.3884-2.8328-8.7186L24 9.4685h-9.1672Zm4.3131 1.5772h-5.459L12 5.8539l-1.6869 5.1918h-5.459l4.4164 3.2087-1.687 5.1918L12 16.2375l4.4164 3.2087-1.6869-5.1918 4.4164-3.2087Z"
    clipRule="evenodd"
  />,
  'MenuUsagePlans'
);
